/**
 * Two behaviours of the shops window of the pickup availability (8 Oct).
 *
 * assets/mm-tokens.css, section 48, turns the native pickup drawer of
 * blocks/buy-buttons.liquid into a centred window.
 *
 * 1. A click on the scrim closes it. At 990px and up assets/theme-drawer.js
 *    opens it with show(), not showModal(), and its click-outside handler only
 *    works in modal mode. The scrim is the ::before of the <theme-drawer>
 *    itself, so a click on it lands on that element and nothing inside the
 *    window does.
 *
 * 2. «Consulta disponibilidad en tienda» opens it. That line of the shipping
 *    box is a text block that links to the shops page (/pages/locaciones).
 *    While the product has pickup shops to show, the click opens the window
 *    instead; with pickup availability switched off in the editor, or no shop
 *    for the product, there is no window and the link goes to the page as
 *    before.
 *
 * If this file fails to load, the window still closes with its button and
 * Escape, and the line is a plain link.
 */

/** @typedef {HTMLElement & { open?: () => void, close?: () => void }} Drawer */

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  if (target.matches('theme-drawer.pickup-drawer[open]')) {
    /** @type {Drawer} */ (target).close?.();
    return;
  }

  const link = target.closest('.product-details a[href$="/pages/locaciones"]');
  if (!link) return;

  const pickup = document.querySelector('local-pickup:not([hidden])');
  const drawer = /** @type {Drawer | null} */ (document.querySelector('theme-drawer.pickup-drawer'));
  if (!pickup || typeof drawer?.open !== 'function') return;

  event.preventDefault();
  drawer.open();
});
